export const ADMIN_ROLE_ID = 1;
export const VIEWER_ROLE_ID = 2;
export const PROFILE_IMAGE_SIZE = 200;
